import { PhotoIcon } from '@heroicons/react/24/outline'
import classNames from 'classnames'
import { ElementType } from 'react'

import { ImageAspectRatio, ImageShape, ImageScaleMode } from './types'

type ImageSizeProps =
    | {
          imageWidthClassName?: never
          imageHeightClassName: string
      }
    | {
          imageWidthClassName: string
          imageHeightClassName?: never
      }

type ImageProps = ImageSizeProps & {
    url?: string
    scaleMode?: ImageScaleMode
    aspectRatio: ImageAspectRatio
    placeholderIcon?: ElementType | string
    placeholderIconSizeClassName?: string
    shape?: ImageShape
}

export const Image = ({
    imageWidthClassName,
    imageHeightClassName,
    url,
    aspectRatio,
    scaleMode = 'cover',
    placeholderIcon,
    placeholderIconSizeClassName,
    shape = 'rounded',
}: ImageProps) => {
    let placeholderElement = null

    if (!url) {
        if (typeof placeholderIcon === 'string') {
            placeholderElement = (
                <div
                    className={classNames('leading-none', placeholderIconSizeClassName, {
                        'text-[20px]': !placeholderIconSizeClassName,
                    })}
                >
                    {placeholderIcon}
                </div>
            )
        } else {
            const PlacholderIcon = placeholderIcon ? placeholderIcon : PhotoIcon
            placeholderElement = (
                <PlacholderIcon
                    className={classNames('text-light', placeholderIconSizeClassName, {
                        'size-5': !placeholderIconSizeClassName,
                    })}
                />
            )
        }
    }

    return (
        <div
            className={classNames(
                imageWidthClassName,
                imageHeightClassName,
                'flex items-center justify-center bg-center bg-no-repeat',
                {
                    'bg-contain': scaleMode === 'contain',
                    'bg-cover': scaleMode === 'cover',
                    'bg-neutral-200 dark:bg-neutral-700': !url,
                    'rounded-md': shape === 'rounded',
                    'rounded-full': shape === 'circle',
                    'aspect-square': aspectRatio === '1/1',
                    'aspect-16/9': aspectRatio === '16/9',
                    'aspect-4/3': aspectRatio === '4/3',
                    'aspect-[820/312]': aspectRatio === '820/312',
                }
            )}
            style={{ backgroundImage: url ? `url("${url}")` : undefined }}
        >
            {placeholderElement}
        </div>
    )
}
